export default "assets/images/icons/play-a85798ee.svg";